import Instafeed from "./instafeed.js";

if ($(".star--rating").length) {
  var post = $(".star--rating").attr("data-current");
  if (document.cookie.match(post)) {
    $(".star--rating").hide();
  }
}

$(".anchor--link").on("click", function (e) {
  e.preventDefault();
  $("html, body").animate(
    {
      scrollTop: $($.attr(this, "href")).offset().top,
    },
    500
  );
});

$(".desktop--nav--button").on("click", function () {
  var target = $(".desktop--nav");
  if (target.hasClass("open")) {
    target.removeClass("open");
    target.addClass("closed");
  } else {
    target.removeClass("closed");
    target.addClass("open");
  }
});

$(".search--button").on("click", function (e) {
  if (!$(this).hasClass("button--open")) {
    e.preventDefault();
    $(".search--bar").toggleClass("open");
    $(this).toggleClass("button--open");
  }
});

$(".mobile--nav--button").on("click", function () {
  var container = $(".mobile--nav");
  var target = $(".dropdown--nav");
  var secondTarget = $(".only--icons--wrapper");
  if (container.hasClass("open")) {
    target.css("max-height", 0);
    var secondHeight = secondTarget.prop("scrollHeight");
    secondTarget.css("max-height", secondHeight);
  } else {
    var height = target.prop("scrollHeight");
    target.css("max-height", height);
    secondTarget.css("max-height", 0);
  }
  container.toggleClass("open");
});

$(".custom--select").on("click", function (e) {
  e.preventDefault();

  if ($(this).hasClass("select--open")) {
    $(this).children("ul").css("max-height", 0);
  } else {
    var height = $(this).children("ul").prop("scrollHeight");
    $(this).children("ul").css("max-height", height);
  }
  $(this).toggleClass("select--open");
});

$(".custom--select--selection").on("click", function (e) {
  e.preventDefault();
  if (!$(this).hasClass("selected")) {
    $(".selected").removeClass("selected");
    $(this).addClass("selected");
    var txt = $(this).attr("data-category");
    $(".the--selected").text(txt);
    var container = $("#ajax--content");
    container.empty();
    container.attr("data-page", 1);
    fetchItems();
  }
});

$(".star--rating span")
  .on("click", function (e) {
    var id = $(this).prop("id");
    var post = $(".star--rating").attr("data-current");
    var url = $(".star--rating").attr("data-url");

    e.preventDefault();

    $.ajax({
      method: "POST",
      url: url + "/wp-json/rating/" + post + "/" + id,
      success: function () {
        document.cookie = post + "=" + id;
        $(".star--rating").hide(500);
        $(".star--thanks").show(500);
      },
    });
  })
  .mouseenter(function () {
    var id = $(this).prop("id");
    if (id > 1) {
      for (id > 1; id--; ) {
        $("#" + id).addClass("active");
      }
      $(this).addClass("active");
    } else {
      $(this).addClass("active");
    }
  })
  .mouseleave(function () {
    $(".star--rating span").removeClass("active");
  });

function fetchItems() {
  var container = $("#ajax--content");
  var sortOption = "date";
  if ($(".selected").length) {
    sortOption = $(".selected").attr("data-sort");
  }
  var tax = container.attr("data-tax");
  var page = container.attr("data-page");
  var homeUrl = container.attr("data-url");
  let dataUrl =
    homeUrl + "/wp-json/custom-rest-route/posts/" + page + "/" + sortOption;
  if (tax !== "") {
    dataUrl =
      homeUrl +
      "/wp-json/custom-rest-route/posts/" +
      tax +
      "/" +
      page +
      "/" +
      sortOption;
  }
  $.ajax({
    type: "GET",
    dataType: "json",
    url: dataUrl,
    success: function (data, textStatus, jqXHR) {
      page++;
      // Get total page count
      var total_pages = parseInt(
        jqXHR.getResponseHeader("X-WP-TotalPages"),
        10
      );
      container.attr("data-page", page);
      appendItems(data);
      if (total_pages < page) {
        $("#ajax--load--more").hide(500);
      } else {
        $("#ajax--load--more").show(500);
      }
      $(".loader").hide(500);
    },
  });
}

$("#ajax--load--more").on("click", function (e) {
  e.preventDefault();
  $(".loader").show(500);
  $(this).hide(500);
  fetchItems();
});

function appendItems(data) {
  var container = $("#ajax--content");

  // console.log(data);

  $.each(data, function (i, item) {
    var link = item.link;
    var title = item.title;
    var highlight = item.highlight ? "highlight" : "";
    var commentCount = item.comments;
    var className = "icon-b category-icon";

    if (item.terms.indexOf(3) >= 0) {
      className = "icon-r category-icon";
    }

    container.append(
      '<figure class="' +
        highlight +
        '"> ' +
        '<a href="' +
        link +
        '" class="image--wrapper"> ' +
        '<div class="overlay--wrapper">' +
        item.image +
        '<div class="overlay--effect"> ' +
        '<span class="icon-logo"></span> ' +
        "</div>" +
        "</div> " +
        "<figcaption> " +
        '<div class="top--bar"> ' +
        '<div class="rating"><span class="icon-bubble"></span><span class="count">' +
        commentCount +
        "</span></div> " +
        '<span class="' +
        className +
        '"></span> ' +
        // '<div class="category">'+taxName+'</div> ' +
        "</div> " +
        "<h2>" +
        title +
        "</h2> " +
        "</figcaption> " +
        "</a> " +
        "</figure>"
    );
  });
}

$(document).ready(function () {
  if ($("#instafeed").length) {
    // eslint-disable-next-line
    var feed = new Instafeed({
      get: "user",
      userId: "467959731",
      accessToken: "467959731.1677ed0.c41b8ab1e1cb4a648e7aa580e162ed77",
      template:
        '<a target="_blank" style="background-image: url(https:{{image}})" class="{{orientation}}" target="_blank" role="link" href="{{link}}"><div class="overlay--hover"><span class="icon-ig"></span></div></a>',
      limit: 12,
      sortBy: "most-recent",
      resolution: "standard_resolution",
    });
    feed.run();
  }

  if ($(".article--content").length) {
    $(".article--content a").each(function () {
      if ($(this).find("> img").length) {
        $(this).addClass("lightbox--image");
        if ($(this).parent().is("p")) {
          $(this).unwrap();
        }
      }
    });

    $(".article--content > p > img").each(function () {
      if ($(this).parent().is("p")) {
        $(this).unwrap();
      }
    });
  }

  if ($(".lightbox--image").length) {
    $(".lightbox--image").magnificPopup({
      removalDelay: 300,
      mainClass: "mfp-fade",
      type: "image",
      closeBtnInside: false,
      gallery: {
        enabled: true,
        tCounter: '<div class="mfp-counter">%curr% / %total%</div>',
      },
    });
  }

  if ($("#ajax--content").length) {
    fetchItems();
  }
});

$(document).keydown(function (e) {
  if ($("body").hasClass("mfp-zoom-out-cur")) {
    e.preventDefault();
    var magnificPopup = $.magnificPopup.instance;
    if (e.keyCode === 38) {
      magnificPopup.prev();
    } else if (e.keyCode === 40) {
      magnificPopup.next();
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/scripts.js